import React, { lazy, Suspense, useContext, useEffect, useState } from "react";
import { Container, Nav, NavDropdown, Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useToken } from "../../account";

import { Tooltip } from "@material-ui/core";
import SettingsIcon from "@material-ui/icons/Settings";
import ShowChartIcon from "@material-ui/icons/ShowChart";
import { useUserContext } from "../../context/userContext";
import { NavbarContext } from "../../globalContext";
import { useSearchAssets } from "../../hooks/useSearchAssets";
import { useSearchUTLSettings } from "../../hooks/useSearchUTLSetting";
import { dxtToLocalServerTime } from "../../services";
import { ErrorModal } from "../modals/error-modal";

const AreaSelector = lazy(() =>
	import("./areaSelector/area-selector").then((mod) => ({
		default: mod.AreaSelector,
	})),
);

export default function Header({
	showAreaSelector = false,
	showTrendingsIcon = true,
	navbarTitle = "MESF",
}: {
	showAreaSelector?: boolean;
	showTrendingsIcon?: boolean;
	navbarTitle?: string;
}) {
	const { getUserName } = useToken();
	const [error, setError] = useState("");
	const [date, setDate] = useState(new Date());
	const CustomNavbar: any = useContext(NavbarContext);
	const [userName] = useState(getUserName());
	const { searchAssets } = useSearchAssets(setError);

	const [settingsIsReady, setSettingsIsReady] = useState<boolean>(false);

	const { searchUTLSettings } = useSearchUTLSettings({
		onError: setError,
	});

	const {
		state: { userLogged },
	} = useUserContext();

	const tick = () => {
		setDate(new Date());
	};

	useEffect(() => {
		const timerID = setTimeout(() => {
			tick();
		}, 1000);
		return () => {
			clearTimeout(timerID);
		};
	});

	useEffect(() => {
		searchUTLSettings().then(() => {
			setSettingsIsReady(true);
		});
	}, []);

	useEffect(() => {
		if (showAreaSelector && userLogged && settingsIsReady) {
			searchAssets();
		}
	}, [userLogged, settingsIsReady]);

	return (
		<Navbar
			variant="dark"
			expand="lg"
			className="mes-primary-color mes-menu-top"
		>
			<Container fluid>
				<Navbar.Brand as={Link} to="/home">
					{navbarTitle}
				</Navbar.Brand>
				<Navbar.Toggle aria-controls="basic-navbar-nav" />
				<Navbar.Collapse id="basic-navbar-nav">
					<Nav className="me-auto">
						<CustomNavbar />
					</Nav>
					<Nav className="ml-auto" style={{ alignItems: "baseline" }}>
						{showTrendingsIcon ? (
							<Nav className="mx-2">
								<Nav.Link as={Link} to="/trendings">
									<Tooltip
										title={"Trendings"}
										placement="top"
										arrow
										interactive
										enterDelay={1500}
									>
										<ShowChartIcon />
									</Tooltip>
								</Nav.Link>
							</Nav>
						) : null}

						<Nav>
							<span className="navbar-text">
								{dxtToLocalServerTime(date, "HH:mm:ss z")}
							</span>
						</Nav>

						<Nav className="mx-2">
							<Nav.Link as={Link} to="/configuration">
								<SettingsIcon />
							</Nav.Link>
						</Nav>

						{showAreaSelector ? (
							<Suspense fallback={"..."}>
								<AreaSelector />
							</Suspense>
						) : null}
						<NavDropdown
							id="user-menu"
							title={
								<>
									<i className="fas fa-user" style={{ marginRight: 6 }}></i>
									{userName}
								</>
							}
							className="mx-2"
						>
							<NavDropdown.Item href="account">Account</NavDropdown.Item>
							<NavDropdown.Item href="logout">Logout</NavDropdown.Item>
						</NavDropdown>
					</Nav>
				</Navbar.Collapse>
			</Container>
			<ErrorModal error={error} onHide={() => setError("")} />
		</Navbar>
	);
}
